module.exports = __webpack_public_path__ + "static/media/editorial.2bf668e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DashboardCard/UnsubmittedProjectCard/editorial.svg
// module id = 1904
// module chunks = 0